import { createContext, useContext, useState } from 'react';

export type RegisterInfo = {
    registerType: string;
}

type RegisterInfoContextProps = {
    registerInfo: RegisterInfo;
    setRegisterInfo: React.Dispatch<React.SetStateAction<RegisterInfo>>;
}

export const RegisterInfoContext = createContext<RegisterInfoContextProps | undefined>(undefined)

type RegisterInfoProviderProps = {
    children: React.ReactNode;
}

export const RegisterInfoProvider = ({ children }: RegisterInfoProviderProps) => {
    const [registerInfo, setRegisterInfo] = useState<RegisterInfo>({ registerType: '' })

    return(
        <RegisterInfoContext.Provider value={{ registerInfo, setRegisterInfo }}>
        {children}
        </RegisterInfoContext.Provider>
    )
}

export const useRegisterInfo = () => {
    const context = useContext(RegisterInfoContext)
    if(!context) {
        throw new Error('useRegisterInfo must be used within a RegisterInfoProvider')
    }
    return context
}
